import { Component } from '@angular/core';
@Component({
standalone: false,
  selector: 'app-send-email-container',
  styleUrls: ['./send-email-container.component.scss'],
  templateUrl: './send-email-container.component.html',
})
export class SendEmailContainerComponent {
  constructor() {}
}
